type ListLike<T> = T[] | {
  __items__?: T[]
  all?: T[]
  [key: string]: T | T[] | undefined
} | null | undefined

function isNumericKey(key: string) {
  return /^\d+$/.test(key)
}

/**
 * Приводит список из SSR-контекста к массиву.
 *
 * Django сериализует related-наборы объектом с числовыми ключами,
 * иногда с `__items__` или `all`. Без этого `v-for` и `.length` молча ломаются.
 */
export default function unwrapList<T>(value: ListLike<T>): T[] {
  if (!value) {
    return []
  }

  if (Array.isArray(value)) {
    return value
  }

  if (Array.isArray(value.__items__)) { // eslint-disable-line no-underscore-dangle
    return value.__items__ // eslint-disable-line no-underscore-dangle
  }

  if (Array.isArray(value.all)) {
    return value.all
  }

  const numericKeys = Object.keys(value).filter(isNumericKey)

  if (!numericKeys.length) {
    return []
  }

  return numericKeys
    .sort((left, right) => Number(left) - Number(right))
    .map(key => value[key] as T)
}
